import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BillabilityUtilizationTarget } from "models/billability-utilization-target";

export interface AdminBillabilityUtilizationTargetsSliceState {
    targets: BillabilityUtilizationTarget[];
    editingTarget: BillabilityUtilizationTarget | null;
}

export const initialState: AdminBillabilityUtilizationTargetsSliceState = {
    targets: [],
    editingTarget: null,
};

const AdminBillabilityUtilizationTargetsSlice = createSlice({
    name: "admin-billability-utilization-targets-slice",
    initialState,
    reducers: {
        setTargets(state, { payload }: PayloadAction<BillabilityUtilizationTarget[]>) {
            state.targets = payload;
        },
        addTarget(state, { payload }: PayloadAction<BillabilityUtilizationTarget>) {
            state.targets = [payload, ...state.targets];
        },
        setTarget(state, { payload }: PayloadAction<BillabilityUtilizationTarget>) {
            const index = state.targets.findIndex(t => t.id === payload.id);
            if (index !== -1) {
                state.targets[index] = payload;
            }
        },
        removeTarget(state, { payload: targetId }: PayloadAction<string>) {
            state.targets = state.targets.filter(t => t.id !== targetId);
        },
        setEditingTarget(state, { payload }: PayloadAction<BillabilityUtilizationTarget | null>) {
            state.editingTarget = payload;
        },
    },
});

export const {
    setTargets,
    addTarget,
    setTarget,
    removeTarget,
    setEditingTarget,
} = AdminBillabilityUtilizationTargetsSlice.actions;

export default AdminBillabilityUtilizationTargetsSlice.reducer;
